import { createFileRoute } from '@tanstack/react-router';

import { DebugView } from 'views/DebugView';

export const Route = createFileRoute('/debug')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DebugView />;
}
